import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer>
            <div className='container'>
                <div className='row footer-copyright'>
                    <div className='col-lg-9 col-md-7'>
                        <div className='row'>
                            <p className='col-lg-8 col-md-12'>
                                © 2019 Motor Image Enterprises Pte Ltd, Co Reg No 198702032R. All rights reserved.
                            </p>
                            <div className='col-lg-4 col-md-12'>
                                <div className='footer-terms_links'>
                                    <a href='https://www.subaru.asia/sg/en/web/terms.php'>Terms &amp; Conditions</a> |  <a href='https://www.subaru.asia/sg/en/web/privacy.php'>Privacy Policy</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-5 footer-terms'>
                        <div className='footer-terms_logos'>
                            <img src={require('../../images/tanchong.png')} alt='' />
                            <img src={require('../../images/motorimage.png')} alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
